import React, { useState, useCallback } from 'react'
import { Link } from 'components'
import { LoginForm } from './LoginForm'
import { LoginWrapper } from '../LoginWrapper'
import classes from './LoginPage.module.scss'
import { useHistory } from 'react-router-dom'
import { useAuthentication } from 'hooks/useAuthentication'
import { useTranslation } from 'react-i18next'

export const LoginPage = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const { login } = useAuthentication()

  const portalUrl = window.REACT_APP_PORTAL_URL

  const [error, setError] = useState<boolean>(false)
  const onSubmit = useCallback(
    async (values: any, { setSubmitting }: any) => {
      setSubmitting(false)
      const success = await login(values.username, values.password)
      if (success) {
        history.push('/bookings')
      }
      if (!success) {
        setError(!success)
      }
    },
    [login, history]
  )

  return (
    <LoginWrapper title={t('pages.login.loginPage.loginPage.title')}>
      {portalUrl && (
        <p className={classes.newPortalInfo}>
          {t('pages.login.loginPage.loginPage.newPortalInfo')}{' '}
          <a href={portalUrl} target="_blank" rel="noopener noreferrer">
            {t('pages.login.loginPage.loginPage.newPortalLinkText')}
          </a>
        </p>
      )}

      {error && (
        <p className={classes.error}>
          {t('pages.login.loginPage.loginPage.error')}
        </p>
      )}

      <div className={classes.form}>
        <LoginForm onSubmit={onSubmit} />
      </div>

      <p className={classes.link}>
        <Link to="/password-reset">
          {t('pages.login.loginPage.loginPage.forgotPassword')}
        </Link>
      </p>

      <p className={classes.link}>
        {t('pages.login.loginPage.loginPage.isAccountExist')}{' '}
        <Link to="/register">
          {t('pages.login.loginPage.loginPage.toRegister')}
        </Link>
      </p>
    </LoginWrapper>
  )
}
